import { crudApi } from "../../../helpers/api_helper";
import { TAG } from "../../../helpers/url_helper";

export default crudApi(TAG);